import React from 'react';

class FirestoreErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a Firestore internal assertion error
    if (error.message && error.message.includes('INTERNAL ASSERTION')) {
      console.warn('Caught Firestore internal assertion error, showing fallback UI');
      return { hasError: true, error: 'firestore_internal' };
    }
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error, errorInfo) {
    console.error('FirestoreErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.state.error === 'firestore_internal') {
        // For Firestore internal errors, just render children with empty data
        return this.props.children;
      }
      
      // For other errors, show error UI
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          color: '#666',
          background: '#f8f9fa',
          borderRadius: '8px',
          margin: '20px'
        }}>
          <h3>Something went wrong</h3>
          <p>There was an error loading the data. Please refresh the page.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              background: '#42bcff',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default FirestoreErrorBoundary;









